import { render, staticRenderFns } from "./CityOfSky.vue?vue&type=template&id=0a5b1271&scoped=true&"
import script from "./CityOfSky.vue?vue&type=script&lang=js&"
export * from "./CityOfSky.vue?vue&type=script&lang=js&"
import style0 from "./CityOfSky.vue?vue&type=style&index=0&id=0a5b1271&scoped=true&lang=css&"
import style1 from "./CityOfSky.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b1271",
  null
  
)

export default component.exports